import React from 'react';
import styles from './LoadingScreen.module.css';
import logoImg from '../../../assets/logob.webp';

export default function LoadingScreen() {
    return (
        <div className={styles.overlay}>
            <img src={logoImg} alt="App Palestra Logo" className={styles.logo} width={200} height="auto" fetchPriority="high" />
            <div className={styles.spinner}></div>
        </div>
    );
}
